import focusManager from '../../../node_modules/focus-manager/focusManager';


export default class Modals {
  constructor() {
    this.modalSelector = '[data-modal]';
    this.overflowClass = 'modal-open';
    this.classHidden = 'hidden';
    this.overlayAttr = 'data-modal-overlay';
    this.modals = [...document.querySelectorAll(this.modalSelector)];
    this.overlay = document.querySelector(`[${this.overlayAttr}]`);
    this.openButtons = [...document.querySelectorAll('[data-modal-for]')];
    this.closeButtons = [...document.querySelectorAll('[data-close-modal]')];
    this.body = document.querySelector('body');
    this.inFocus = null;
    this.onKeyUpWindowHandler = null;
    this.overlayClickHandler = null;
  }

  openHandler() {
    this.openButtons.forEach((button) => {
      const forModal = button.dataset.modalFor;
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.open(forModal);
      })
    });
  }

  closeHandler() {
    this.closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
        this.close(button.closest(this.modalSelector));
      })
    });
  }

  close(modal = this.modals.find((m) => !m.classList.contains(this.classHidden))) {
    if (!modal) return;
    focusManager.release();
    modal.classList.add(this.classHidden);
    modal.setAttribute('tabindex', 1);
    if (this.modals.find((m) => !m.classList.contains(this.classHidden))) return;
    this.inFocus.focus();
    this.body.classList.remove(this.overflowClass);
    this.overlay.classList.add(this.classHidden);
    document.removeEventListener('keyup', this.onKeyUpWindowHandler);
    this.overlay.removeEventListener('click', this.overlayClickHandler);
  }

  open(forModal, callback) {
    const modal = this.modals.find((m) => m.dataset.modal === forModal);
    if (!modal) return;

    const currentOpenModal = this.modals.find((m) => !m.classList.contains(this.classHidden));

    if (currentOpenModal === modal) {
      this.close(modal);
      return;
    }

    modal.classList.remove(this.classHidden);
    modal.setAttribute('tabindex', -1);
    setTimeout(() => {
      modal.focus();
      focusManager.capture(modal);
    }, 100);

    if (currentOpenModal) {
      this.close(currentOpenModal);
      return;
    }

    this.inFocus = document.activeElement;
    this.overlay.classList.remove(this.classHidden);
    this.body.classList.add(this.overflowClass);

    this.onKeyUpWindowHandler = (e) => {
      if (e.key !== 'Escape' || e.keyCode !== 27) return;
      const modal = this.modals.find((m) => !m.classList.contains(this.classHidden));
      if (!modal) return;
      this.close(modal);
    };

    document.addEventListener('keyup', this.onKeyUpWindowHandler);

    this.overlayClickHandler = (e) => {
      if (!e.target.hasAttribute(this.overlayAttr)) return;
      this.close();
    };

    this.overlay.addEventListener('click', this.overlayClickHandler);

    if (callback) {
      callback(modal);
    }
  }

  init() {
    this.openHandler();
    this.closeHandler();
  }
}

// init modals
export const modals = new Modals();
modals.init();